import React from "react"
import { Link as GatsbyLink, GatsbyLinkProps } from "gatsby"
import { Link as CustomLink, LinkProps } from "@chakra-ui/react"

interface GatsbyProps extends Omit<GatsbyLinkProps<Record<string, unknown>>, '"ref"'> {
  external?: boolean
  state?: any
}

type Props = GatsbyProps & LinkProps

// eslint-disable-next-line
const Link: React.FC<Props> = React.forwardRef(({ children, to = "", external = false, state = {}, ...other }, ref) => {
  const internal = /^\/(?!\/)/.test(to)

  return internal && !external ? (
    <CustomLink as={GatsbyLink} to={to} state={state} {...other}>
      {children}
    </CustomLink>
  ) : (
    <CustomLink href={to} {...(external && { isExternal: true, target: "_blank", rel: "noreferrer" })} {...other}>
      {children}
    </CustomLink>
  )
})

export default React.memo(Link)
